export enum SUBSCRIPTION_ACTION_TYPES {
  GET_SUBSCRIPTION = 'GET_SUBSCRIPTION',
  CREATE_SUBSCRIPTION = 'CREATE_SUBSCRIPTION',
  UPDATE_SUBSCRIPTION = 'UPDATE_SUBSCRIPTION',
  UPDATE_AUTOPAY = 'UPDATE_AUTOPAY',
  GET_SUBSCRIPTION_WITHDRAWAL_DATE_OPTIONS = 'GET_SUBSCRIPTION_WITHDRAWAL_DATE_OPTIONS',
}
